// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__28c6z","inputWrap":"styles_inputWrap__2N3nw","input":"styles_input__2wpaW"};